export enum LimaOrderStatus {
  undefined = -1,
  Mottagen = 10,
  Orderkontroll = 20,
  Kontrollerad = 40,
  Levererad = 100,
  Struken = 510,
  Frusen = 520,
  Utredning = 530,
}
